var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTermsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 84,
    viewBox: "0 0 70 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4745 0H8.75C3.9235 0 0 3.927 0 8.75V84H70V25.5255L44.4745 0ZM45.5 5.9745L64.0255 24.5H45.5V5.9745ZM14 35H56V38.5H14V35ZM14 49H56V52.5H14V49ZM52.7975 62.0235L55.706 63.973C55.5415 64.218 51.597 70.0035 43.75 70.0035C39.361 70.0035 36.6065 68.4915 34.1775 67.158C31.829 65.87 29.799 64.7535 26.341 64.7535H26.264C20.629 64.7815 17.1885 69.258 17.1535 69.3L14.3465 67.2105C14.525 66.969 18.8195 61.292 26.2395 61.2535H26.334C30.6915 61.2535 33.4355 62.7585 35.861 64.0885C38.22 65.3835 40.2605 66.5035 43.75 66.5035C49.6755 66.5035 52.675 62.2055 52.7975 62.0235Z",
    fill: "#636363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsIcon);
export default __webpack_public_path__ + "static/media/TermsIcon.6f5ad460d1210f45af21b253187894ad.svg";
export { ForwardRef as ReactComponent };